import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';

import PlatformChargeSettings from 'admin/components/settings/PlatformChargeSettings';
import SkillsSettings from 'admin/components/settings/SkillsSettings';
import { useSearchParams } from 'react-router-dom';

const SettingsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 'platform';

  const handleTabChange = (newTab: 'platform' | 'skills') => {
    setSearchParams({ tab: newTab });
  };

  return (
    <Box
      sx={{
        backgroundColor: '#f9fafc',
        display: 'flex',
        minHeight: '80vh',
        px: { md: 4, sm: 3, xs: 2 },
        py: { sm: 6, xs: 3 },
      }}
    >
      <Box
        sx={{
          backgroundColor: '#f0f4f8',
          borderRadius: 2,
          borderRight: '1px solid #e0e0e0',
          boxShadow: 1,
          mr: 4,
          width: { sm: '220px', xs: '160px' },
        }}
      >
        <Typography
          sx={{ p: 2 }}
          color="primary.main"
          fontWeight="bold"
          variant="h5"
        >
          Settings
        </Typography>
        <List>
          <ListItemButton
            selected={tab === 'platform'}
            onClick={() => handleTabChange('platform')}
            sx={{
              '&:hover': {
                backgroundColor: '#e3f2fd',
              },
              backgroundColor: tab === 'platform' ? '#e3f2fd' : 'transparent',
              borderLeft:
                tab === 'platform'
                  ? '4px solid #1976d2'
                  : '4px solid transparent',
              px: 2,
              py: 1.5,
            }}
          >
            <ListItemText primary="Platform Charge" />
          </ListItemButton>
          <ListItemButton
            selected={tab === 'skills'}
            onClick={() => handleTabChange('skills')}
            sx={{
              '&:hover': {
                backgroundColor: '#e3f2fd',
              },
              backgroundColor: tab === 'skills' ? '#e3f2fd' : 'transparent',
              borderLeft:
                tab === 'skills'
                  ? '4px solid #1976d2'
                  : '4px solid transparent',
              px: 2,
              py: 1.5,
            }}
          >
            <ListItemText primary="Skills" />
          </ListItemButton>
        </List>
      </Box>

      <Box
        sx={{
          backgroundColor: 'background.paper',
          borderRadius: 2,
          boxShadow: 3,
          flex: 1,
          p: 4,
        }}
      >
        {tab === 'platform' && <PlatformChargeSettings />}
        {tab === 'skills' && <SkillsSettings />}
      </Box>
    </Box>
  );
};

export default SettingsPage;
